import RouterPage from "./Pages/RouterPage";
import * as React from "react";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <RouterPage />
      </HelmetProvider>
    </div>
  );
}

export default App;
